import types from '../mutation-type'

export default {
  state: {
    examType: '',
    examStudyStep: 'high',
    examGrade: '12',
    examSchoolClassInfo: [],
    examSchoolTeachingClassInfo: []
  },

  actions: {
    // 记录考试类型
    recordExamType ({ commit }, data) {
      commit(types.RECORD_EXAM_TYPE, data)
    },
    // 记录参考年级
    recordExamStudyStep ({ commit }, data) {
      commit(types.RECORD_EXAM_STUDY_STEP, data)
    }, // 记录参考年级
    recordExamSchoolClassInfo ({ commit }, data) {
      commit(types.RECORD_EXAM_SCHOOL_CLASSINFO, data)
    },
    recordExamSchoolTeachingClassInfo ({ commit }, data) {
      commit(types.RECORD_EXAM_SCHOOL_TEACHINGCLASSINFO, data)
    }
  },

  mutations: {
    // 记录考试类型
    [types.RECORD_EXAM_TYPE] (state, examType) {
      state.examType = examType
    },
    // 记录参考年级
    [types.RECORD_EXAM_STUDY_STEP] (state, examGrade) {
      state.examGrade = examGrade
      examGrade = parseInt(examGrade)
      if (examGrade > 9 && examGrade < 13) {
        state.examStudyStep = 'high'
      } else if (examGrade > 6 && examGrade < 10) {
        state.examStudyStep = 'junior'
      } else if (examGrade > 0 && examGrade < 7) {
        state.examStudyStep = 'primary'
      }
    },
    // 记录学校创建考试流程中班级信息
    [types.RECORD_EXAM_SCHOOL_CLASSINFO] (state, classInfo) {
      state.examSchoolClassInfo.splice(0, state.examSchoolClassInfo.length)
      state.examSchoolClassInfo = [...classInfo]
    },
    // 记录学校创建考试流程中教学班信息
    [types.RECORD_EXAM_SCHOOL_TEACHINGCLASSINFO] (state, teachingClassInfo) {
      state.examSchoolTeachingClassInfo.splice(0, state.examSchoolTeachingClassInfo.length)
      state.examSchoolTeachingClassInfo = [...teachingClassInfo]
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/exam.js